import { MultiSelect } from '@tmov/design-system';
import { SpinnerMedium } from '@tmov/design-system/icons';
import { Form, notification } from 'antd';
import React, { useEffect, useState } from 'react';

import { LoadingContainer } from '../../../../components/LoadingContainer';
import { toTitleCase } from '../../../../helpers/formatador';
import apiATS from '../../../../services/apiATS';
import FormSection from '../FormSection';
import { SectionInputsRow } from '../FormSection/styles';

function Transporte() {
  const [tiposCavalosOptions, setTiposCavaloOptions] = useState([]);
  const [tiposCarretasOptions, setTiposCarretaOptions] = useState([]);

  useEffect(() => {
    async function carregaFiltros() {
      try {
        const tiposCavalos = await apiATS.get('/MapaAts/GetTipoCavalos');
        const tiposCarretas = await apiATS.get('/MapaAts/GetTipoCarretas');

        setTiposCavaloOptions(
          tiposCavalos.data.dados.tiposCavalos.map(tipoCavalo => ({
            id: tipoCavalo.IdTipoCavalo,
            label: `${toTitleCase(tipoCavalo.Nome)}`,
            checked: false,
          }))
        );
        setTiposCarretaOptions(
          tiposCarretas.data.dados.tiposCavalos.map(tipoCarreta => ({
            id: tipoCarreta.IdTipoCarreta,
            label: `${toTitleCase(tipoCarreta.Nome)}`,
            checked: false,
          }))
        );
      } catch (e) {
        notification.error({
          message:
            'Ops, não conseguimos recuperar os tipos de veículos e carretas.',
          description:
            'Caso o problema persista, entre em contato com nosso suporte.',
        });
      }
    }

    carregaFiltros();
  }, []);

  return (
    <>
      <FormSection
        name="Transporte"
        description="Selecione os veículos e carretas permitidas."
        isLast
      >
        {tiposCavalosOptions.length !== 0 &&
        tiposCarretasOptions.length !== 0 ? (
          <SectionInputsRow>
            <Form.Item
              name="tiposCavalos"
              valuePropName="options"
              initialValue={tiposCavalosOptions}
              wrapperCol={{ style: { gap: 12 } }}
            >
              <MultiSelect
                data-testid="multiselect-veiculos"
                label={`Veículos permitidos (${tiposCavalosOptions.length} opções)`}
                style={{ width: 350 }}
              />
            </Form.Item>
            <Form.Item
              name="tiposCarretas"
              valuePropName="options"
              initialValue={tiposCarretasOptions}
              wrapperCol={{ style: { gap: 12 } }}
            >
              <MultiSelect
                data-testid="multiselect-carretas"
                label={`Carretas permitidas (${tiposCarretasOptions.length} opções)`}
                style={{ width: 350 }}
              />
            </Form.Item>
          </SectionInputsRow>
        ) : (
          <LoadingContainer height="10px">
            <SpinnerMedium />
          </LoadingContainer>
        )}
      </FormSection>
    </>
  );
}

export default Transporte;
